export var ENVS;
(function (ENVS) {
    ENVS["DEV"] = "dev";
    ENVS["PREVIEW"] = "preview";
    ENVS["LIVE"] = "live";
})(ENVS || (ENVS = {}));
